import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridItemStyle } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        border: 1px solid ${getColor("common.border")};
        padding: 1rem;
    `,
};
wishListCardStyles.wishListInfoGridItem = {
    width: [10, 10, 8, 9, 9],
    align: "middle",
};
wishListCardStyles.basicInfoGridItem = { width: [12, 12, 12, 4, 4] };
wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
        font-size: 1rem;
        text-transform: capitalize;
        > ${StyledButton} {
            > ${TypographyStyle} {
                color: ${getColor("primary")};
            }
        }
    `,
};
wishListCardStyles.descriptionText = {
    ellipsis: true,
    size: 16,
};
wishListCardStyles.extendedInfoGridItem = {
    width: [12, 12, 12, 8, 8],
    align: "middle",
};
wishListCardStyles.sharingStatusGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        align-items: center;
    `,
};

wishListCardStyles.actionGridItem = {
    width: [2, 2, 4, 3, 3],
    align: "top",
    css: css`
        justify-content: flex-end;
        align-items: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        align-items: flex-start;
                    `,

                    css`
                        align-items: flex-start;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

wishListCardStyles.actionGridMediumHidden = {
    css: css``,
};
wishListCardStyles.actionAddToCartButton = {
    color: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
        padding: 0;
        outline: none;
        border: none;
        margin-right: 5px;
        font-family: "Roboto-Medium" !important;
        &:focus {
            outline: none;
        }
        ${TypographyStyle} {
            font-size: 16px;
        }
    `, // keep text from wrapping
};
wishListCardStyles.actionLeaveButton = {
    variant: "secondary",
    css: css`
        width: auto;
        margin-top: 10px;
    `,
};
wishListCardStyles.sharingStatus = {
    statusText: {
        size: 14,
    },
};
wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        font-family: "Roboto-Medium" !important;
    `,
};

wishListCardStyles.actionDeleteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        font-family: "Roboto-Medium" !important;
    `,
};
